import { type RemoteFile, type RemoteImage } from './storage'

export enum ImageSize {
  large = 'large',
  medium = 'medium',
  small = 'small',
}

export const getImageSize = (image: RemoteImage, size: ImageSize): RemoteFile | null => (image ? image?.[size] : null)
